export default "__VITE_ASSET__DqGduPKb__"